import axios from "axios";

export const getScrapForPO = async (productionOrderNo, operationNumber, companyId, reportedBySystem) => {
    const response = await axios.get(`api/productionorderscrap?productionOrderNo=${productionOrderNo}&operationNumber=${operationNumber}&companyId=${companyId}&reportedBySystem=${reportedBySystem}`);
    const data = response.data;
    return data;
}

export const reportScrap = async (productionOrder) => {
    const response = await axios.post(`api/productionorderscrap`, productionOrder);
    const data = response.data;
    return data;
}


export const getScrapReasonCodes = async (companyId) => {
    const response = await axios.get(`api/scrapreasoncodes?companyId=${companyId}`);
    const data = response.data;
    return data;
}